export default __webpack_public_path__ + "static/media/home__about--groups.0d29d443.jpg";